import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { LayoutComponent  } from '././layout.component';
 
const routes: Routes = [
  {
    path: '',
    component: LayoutComponent,
    children: [
      { path: 'dashboard', loadChildren: '../admin/dashboard/dashboard.module#DashboardModule' },
      { path: 'company', loadChildren: '../admin/company/company.module#CompanyModule' },
      { path: 'products', loadChildren: '../admin/products/products.module#ProductsModule' },
      { path: 'customer', loadChildren: '../admin/customer/customer.module#CustomerModule' },
      { path: 'settings', loadChildren: '../admin/settings/settings.module#SettingsModule' },
      { path: 'reports', loadChildren: '../admin/reports/reports.module#ReportsModule' },
      { path: 'inventory', loadChildren: '../admin/inventory/inventory.module#InventoryModule' },
      { path: 'permissions', loadChildren: '../admin/permissions/permissions.module#PermissionsModule' },
      { path: 'invoices', loadChildren: '../admin/invoices/invoices.module#InvoicesModule' },
      { path: 'marketplace', loadChildren: '../admin/marketplace/marketplace.module#MarketplaceModule' },
      
      { path: 'accounting', loadChildren: '../admin/accounting/accounting.module#AccountingModule' },
      { path: 'accessdenied', loadChildren: '../admin/404/404.module#AccessDeniedModule' }
    ]

  },


];
@NgModule({
  imports: [RouterModule.forRoot(routes, {useHash : false})],
  exports: [RouterModule]
})

export class LayoutRoutingModule { }
